import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type React from "react";

import FormAnchor from "../Form/FormAnchor";
import FormField from "../FormField";
import Label from "../Label";
import {Box} from "../ui/box";
import {VStack} from "../ui/vstack";

export type Props = {
    label?: React.ReactNode;
    children: React.ReactNode;
    error?: string;
} & StrictUnion<
    | {
          name?: string;
      }
    | {
          isInsideTab: true;
          name: string;
      }
>;

const formGroupStyles = tva({
    base: "flex flex-col border border-solid rounded-md p-4",
    variants: {
        error: {
            true: "border-danger-500 ring-danger-500 ring-1",
            false: "border-blueGray-200"
        }
    }
});

const FormGroup: React.FC<Props> = ({label, error, name, children}) => {
    const bodyNode = (
        <Box className={formGroupStyles({error: !!error})}>
            {name && process.env.IS_WEB && <FormAnchor name={name} />}
            <FormField error={error}>
                <VStack space="lg">{children}</VStack>
            </FormField>
        </Box>
    );

    if (label) {
        return (
            <Box>
                <Label size="xs">{label}</Label>
                {bodyNode}
            </Box>
        );
    }

    return bodyNode;
};

export default FormGroup;
